export class DrawingNationalCupRequest {
    matchDay: number;
    stage: number;
}